import classes from "./Config.module.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { useEffect, useRef, useState } from "react";
import { Modal, ModalFooter, ModalHeader, ModalTitle } from 'react-bootstrap';
import $ from 'jquery';
import ConfigsService from "../../Services/ConfigurationService";
import { ReactComponent as Error } from '../../Assets/img/Error.svg';
import { ReactComponent as AddIcon } from '../../Assets/img/AddIcon.svg';
import { ReactComponent as ResetIcon } from '../../Assets/img/Reset-primary-icon.svg';

function EditConfig(props) {
    const ConfigKey = props.ConfigKey;
    const configKeyInputRef = useRef();
    const configValueInputRef = useRef();
    const [error, setError] = useState("");
    const [messagePopup, setMessagePopup] = useState(false);

    useEffect(() => {
        loadConfigValue();
    }, [])

    function loadConfigValue() {
        ConfigsService.getConfig(ConfigKey)
            .then((response) => {
                var configKey = $('#configKey').val();
                var data = [];
                if (configKey == "DeviceCrtStorageOption") {
                    data = ["FileSystem", "TPM", "Registry"];
                } else if (configKey == "KeyCombination") {
                    data = ["PerSBI", "PerModality"];
                }

                var configValue = "<select id='configValue'>";

                for (var i = 0; i < data.length; i++) {
                    if (response.response[0].ConfigValue === data[i]) {
                        configValue = configValue + '<option value=' + data[i] + ' selected>' + data[i] + '</option>';
                    }
                    else {
                        configValue = configValue + '<option value=' + data[i] + '>' + data[i] + '</option>';
                    }
                }
                configValue = configValue + '</select>';
                $('#configValue').html(configValue);
            })
    }

    function updateHandler(event) {
        event.preventDefault();

        const enteredConfigKey = configKeyInputRef.current.value;
        const enteredConfigValue = configValueInputRef.current.value;

        var configDTO = {
            ConfigKey: enteredConfigKey,
            ConfigValue: enteredConfigValue
        };

        ConfigsService.updateConfig(configDTO)
            .then((response) => {
                if (response.response == null) {
                    setError(response.errors[0].message);
                    setMessagePopup(true);
                } else {
                    props.onClose();
                    props.onShowMessage("Configuration edited sucessfully.");
                }
            })
            .catch((err) => {
                setError(err.data);
                setMessagePopup(true);
            });
    }

    return (
        <Modal centered={true} contentClassName="AddDeviceMain" show={true} onHide={props.onClose}>

            <ModalHeader className="AddDeviceHeader" style={{ border: "none" }} closeButton >
                <ModalTitle className="Header">
                    <strong>Edit Configuration</strong>
                </ModalTitle>
            </ModalHeader>
            <Modal.Body style={{ padding: '0' }}>
                {messagePopup && (
                    <div className="alert alert-warning"><Error /><span className="message-popup-title">{error}</span></div>
                )}
                <form onSubmit={updateHandler}>
                    <div style={{ padding: '3%' }}>
                        <div>
                            <label for="ConfigKey" className="label">Config Key</label>
                            <div>
                                <input id="configKey" className="InputField" readOnly={true} value={ConfigKey} ref={configKeyInputRef} required />
                            </div>
                        </div>
                        <br />
                        <div>
                            <label for="ConfigValue" className="label">Config Value</label>
                            <div>
                                <select id="configValue" className="InputField" ref={configValueInputRef} required>
                                    <option value="null" selected disabled>-Select-</option>
                                </select>
                            </div>
                        </div>
                    </div>

                    <ModalFooter className="AddDeviceFooter" style={{ border: "none" }}>
                        <div>
                            <button type="reset" className="secondary-button">
                                <span className="secondary-button-icon"><ResetIcon /></span>
                                <span className="secondary-button-text">Reset</span>
                            </button>
                            &nbsp;
                            <button type="submit" className="primary-button ">
                                <span className="primary-button-icon"><AddIcon /></span>
                                <span className="primary-button-text">Edit Config</span>
                            </button>

                        </div>
                    </ModalFooter>
                </form>
            </Modal.Body>

        </Modal >
    );
}

export default EditConfig;